import styled from 'styled-components'
import { grey500 } from 'material-ui/styles/colors'
import { white } from 'material-ui/styles/colors'

/* Containers */
export const Container = styled.div`
  display: flex;
  justify-content: ${props =>
    props.start
      ? 'flex-start'
      : props =>
          props.end ? 'flex-end' : props => (props.between ? 'space-between' : props => (props.around ? 'space-around' : 'center'))};
  align-items: ${props =>
    props.alignEnd
      ? 'flex-end'
      : props =>
          props.alignCenter
            ? 'center'
            : props => (props.alignStretch ? 'stretch' : props => (props.alignBaseline ? 'baseline' : 'flex-start'))};
  flex-wrap: ${props => (props.wrap ? 'wrap' : props => (props.reverse ? 'wrap-reverse' : 'nowrap'))};
`

export const Item = styled.div.attrs({
  size: props => props.size || '0 1 auto'
})`
  flex: ${props => props.size};
`

export const Spacer = styled.div.attrs({
  size: props => props.size || '24px'
})`
  margin-top: ${props => props.size};
`

export const Padding = styled.div.attrs({
  size: props => props.size || '24px'
})`
  padding: ${props => props.size};
`

export const Margin = styled.div.attrs({
  size: props => props.size || '0px'
})`
  margin: ${props => props.size};
`



// WEBPACK FOOTER //
// src/components/UI/StyledComponents.js